import { TableOrders } from "components/tables/TableOrders";
import { Main } from "components/pages";

export default function ManageOrders() {
  return (
    <>
      {/* <PageHeader title="Gerenciar Encomendas" /> */}

      <Main>
        <section>
          <TableOrders />
        </section>
      </Main>
    </>
  );
}
